<template>
  <!-- <div class="white pa-0" > -->
    <!-- <v-row class="text-center px-0"> -->

      <!-- ряд 2 -->
      <v-col class="teal lighten-5 mb-5 py-0" cols="12">
        <v-col
          class="teal lighten-5 mb-5 py-0 col-md-10 offset-md-1 col-12 offset-0"
        >
          <div class="teal lighten-5 " style="height: 70px"></div>
          <h2
            class="headline font-weight-bold mb-3"
            style="letter-spacing: 0.13125em !important; color: #616161"
          >
            ЧТО ДЕЛАЕМ
          </h2>
          <v-divider
            class="grey darken-2 mx-auto"
            light
            style="min-height: 3px; max-width: 50px"
          ></v-divider>
          <v-row justify="center">
            <v-col
              v-for="(item, k) in ecosystem"
              :key="k"
              class="col-sm-4 offset-sm-1 col-md-3 offset-md-0 col-12"
            >
              <!-- class="col-md-3 col-12" -->
              <v-card
                flat
                class="teal lighten-5 pb-0 mt-1 anchor-element"
                height="250"
              >
                <v-sheet light>
                  <v-card-text class="teal lighten-5">
                    <v-row justify="center">
                    <v-avatar
                        size="12em"
                        class="d-inline-flex teal"
                      >
                    <v-avatar
                        size="11em"
                        class="d-inline-flex  teal accent-1 "
                      >
                      <!-- white -->
                      <!-- cyan accent-1 -->
                      <!-- teal accent-1 -->
                      <!-- lime darken-1 -->
                      <!-- light-green accent-1 -->
                      <!-- green accent-2 -->
                      <v-avatar
                        size="10em"
                        class="teal lighten-1 d-inline-flex "
                      >
                        <v-icon
                          class="pa-0 ma-0"
                          size="6em"
                          dark
                          v-html="item.icon"
                        >
                        </v-icon>
                      </v-avatar>
                      </v-avatar>
                      </v-avatar>
                    </v-row>
                    <v-row justify="center" class="mt-2">
                      <v-card-title class="body-1 text--darken-1 text-center">
                        <!-- <p class="base-body body-1  text--darken-1 text-center "> -->
                        <div
                          class="textMainPage textWordBreak"
                          data-aos="fade-up"
                          data-aos-offset="100"
                          :data-aos-delay="item.delay"
                          data-aos-duration="1000"
                          data-aos-easing="ease-out-back"
                          data-aos-mirror="true"
                          data-aos-once="false"
                          data-aos-anchor-placement="bottom-bottom"
                          data-aos-anchor=".anchor-element"
                        >
                          {{ item.text }}
                        </div>

                        <!-- </p>   -->
                      </v-card-title>
                    </v-row>
                  </v-card-text>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
          <div class="teal lighten-5" style="height: 100px"></div>
        </v-col>
      </v-col>
    <!-- </v-row> -->


  <!-- </div> -->
</template>



<script>
export default {
  name: "SectionTwo",
  data() {
    return {
       ecosystem: [
        {
          text: "Даём приют бездомным животным",
          icon: "mdi-home",
          delay: "1",
        },
        {
          text: "Оказываем медицинскую помощь",
          icon: "mdi-ambulance",
          delay: "150",
        },
        {
          text: "Помогаем найти новых хозяев",
          icon: "mdi-account-supervisor",
          delay: "300",
        },
        {
          text: "Кормим, поим, любим наших питомцев",
          icon: "mdi-heart",
          delay: "450",
        },
      ],
    };
  },


};
</script>

<style scoped>

.border-style {
  border: 16px solid #2962FF;
}
 
</style>
